import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'input', 'confirmButton', 'cancelButton']
  static values = {
    name: String
  }

  connect() {
    this.disableConfirmButton()
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.disableConfirmButton()
  }

  hide() {
    this.modalTarget.classList.add('hidden')
  }

  checkInput() {
    const inputValue = this.inputTarget.value.trim()
    if (inputValue === this.nameValue) {
      this.enableConfirmButton()
    } else {
      this.disableConfirmButton()
    }
  }

  enableConfirmButton() {
    this.confirmButtonTarget.className =
      this.confirmButtonTarget.className.replace(
        'bg-gray-400 cursor-not-allowed',
        'bg-red-600 hover:bg-red-700'
      )
  }

  disableConfirmButton() {
    this.confirmButtonTarget.className =
      this.confirmButtonTarget.className.replace(
        'bg-red-600 hover:bg-red-700',
        'bg-gray-400 cursor-not-allowed'
      )
  }

  cancel() {
    this.hide()
  }

  // Handle escape key
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.hide()
    }
  }
}
